import { render, staticRenderFns } from "./UgcList.vue?vue&type=template&id=73b1cc13"
import script from "./UgcList.vue?vue&type=script&lang=js"
export * from "./UgcList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports